<div class="slick marquee">
  <div class="slick-slide" *ngFor="let image of sliderImages; let i = index">
    <div class="inner">
      <img src="{{ image }}" alt="Placeholder" />
    </div>
  </div>
</div>
